import { loginByPwd, logout, getInfo, loginByEmail, loginByPhone, loginByTokenApi } from '@/api/user'
import { getToken, setToken, removeToken, setStep, setRoleId, clearAllCookies, setUserInfo,setVenueCode } from '@/utils/auth'
import router, { resetRouter } from '@/router';
import md5 from 'js-md5'


const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  userInfo: {},
  currentExhibitionName: '暂无展会', //当前展会名称
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USER_INFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_CURRENT_EXHIBITION_NAME: (state, currentExhibitionName) => {
    state.currentExhibitionName = currentExhibitionName
  }
}

const actions = {
  // user/login
  login({ commit }, params) {
    if(params.loginType === 'phone'){
      const { phone, verifyCode } = params
      return new Promise((resolve, reject) => {
        loginByPhone({ phone: phone.trim(), verifyCode: verifyCode }).then(response => {
          console.log('login === response',response)
          const data = response
          if(data.venueCode){
            setVenueCode(data.venueCode)
          }
          localStorage.setItem('companyName',data.cpyName)
          commit('SET_TOKEN', data.token)
          commit('SET_USER_INFO', data)
          setUserInfo(data)
          setToken(data.token)
          setStep(data.step)
          setRoleId(data.role)
          resolve(data)
        }
        ).catch(error => {
          reject(error)
        }
        )
      }
      )

    }else if(params.loginType === 'email'){
      const { email, verifyCode } = params
      return new Promise((resolve, reject) => {
        loginByEmail({ email: email.trim(), verifyCode : verifyCode }).then(response => {
          console.log('login === response',response)
          const data = response
          if(data.venueCode){
            setVenueCode(data.venueCode)
          }
          localStorage.setItem('companyName',data.cpyName)
          commit('SET_TOKEN', data.token)
          commit('SET_USER_INFO', data)
          setUserInfo(data)
          setToken(data.token)
          setStep(data.step)
          setRoleId(data.role)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      }
      )
    }else{
      const { username, password } = params
      return new Promise((resolve, reject) => {
        loginByPwd({ userName: username.trim(), pwd: md5(password) }).then(response => {
          console.log('login === response',response)
          const data = response
          if(data.venueCode){
            setVenueCode(data.venueCode)
          }
          localStorage.setItem('companyName',data.cpyName)
          commit('SET_TOKEN', data.token)
          commit('SET_USER_INFO', data)
          setUserInfo(data)
          setToken(data.token)
          setStep(data.step)
          setRoleId(data.role)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }

  },

  // user/loginByToken
  loginByToken({ commit }, token) {
    return new Promise((resolve, reject) => {
      console.log('loginByToken === token',token)
      loginByTokenApi({ token: token }).then(response => {
        console.log('loginByToken === response',response)
        const data = response
        if(data.venueCode){
          setVenueCode(data.venueCode)
        }
        localStorage.setItem('companyName',data.cpyName)
        commit('SET_TOKEN', data.token)
        commit('SET_USER_INFO', data)
        setUserInfo(data)
        setToken(data.token)
        setStep(data.step)
        setRoleId(data.role)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response
        console.log('user === ',response)
        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        commit('SET_USER_INFO', {})
        removeToken()
        clearAllCookies()
        resetRouter()
        localStorage.setItem('companyName','')
        // 重置 permission 模块路由，防止切换角色后残留旧路由
        commit('permission/RESET_ROUTES', null, { root: true })
        // 清理 localStorage 中残留的用户/展会信息
        localStorage.removeItem('userInfo')
        localStorage.removeItem('currentExhibitionGuid')
        localStorage.removeItem('currentExhibitionName')
        localStorage.removeItem('exhibitionManageMethod')
        localStorage.removeItem('logo')
        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    console.log('changeRoles ',role)
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  },
  // 设置当前展会名称
  setCurrentExhibitionName({ commit }, currentExhibitionName) {
    commit('SET_CURRENT_EXHIBITION_NAME', currentExhibitionName)
  },
  // 切换场馆
  switchVenue({ commit ,state}, result) {
    // 重置企业名称
    localStorage.setItem('companyName',result.cpyName)
    let oldUserInfo = JSON.parse(localStorage.getItem('userInfo'))
    let newUserInfo = {
      ...oldUserInfo,
      venueCode: result.venueCode,
      isAdmin: result.isAdmin,
      cpyName: result.cpyName,
      step: result.step,
    }
    localStorage.setItem('userInfo', JSON.stringify(newUserInfo))
  },
  // 切换企业 切换注册资料
  switchCompany({ commit ,state}, result) {
    // 重置企业名称
    localStorage.setItem('companyName',result.cpyName)
    let oldUserInfo = JSON.parse(localStorage.getItem('userInfo'))
    let newUserInfo = {
      ...oldUserInfo,
      isAdmin: result.isAdmin,
      cpyName: result.cpyName,
      step: result.step,
    }
    localStorage.setItem('userInfo', JSON.stringify(newUserInfo))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
